/* eslint-disable no-plusplus */
import * as Excel from 'exceljs/dist/exceljs.min.js';
import axios from 'axios';

const getDuration = (durationTime) => {
  if (durationTime instanceof Date) {
    return (durationTime.getUTCHours() * 60) + durationTime.getUTCMinutes();
  } if (!Number.isNaN(durationTime)) {
    return durationTime;
  }
  return null;
};

const getDate = (day, month, year, time) => {
  if (year === undefined || month === undefined || day === undefined) {
    return null;
  } if (time === undefined) {
    return new Date(year, month - 1, day, 9, 0);
  }
  return new Date(year, month - 1, day, time.getUTCHours(), time.getUTCMinutes());
};

const findCountryCode = ((workbook, country) => {
  const worksheet = workbook.getWorksheet(1);
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i < 249; i++) {
    if (country === worksheet.getRow(i).getCell(22).text.toLowerCase()) {
      return worksheet.getRow(i).getCell(23).text.toLowerCase();
    }
  }
  return null;
});

function getReminder(reminderStr) {
  let reminder = Number(reminderStr.slice(0, 1));
  if (reminderStr.includes('hour')) {
    reminder *= 60;
  } else if (reminderStr.includes('day')) {
    reminder *= 60 * 24;
  } else if (reminderStr.includes('minutes before')) {
    reminder = Number(reminderStr.replace(' minutes before', ''));
  } else if (Number.isNaN(reminder)) {
    reminder = -1;
  }
  return reminder;
}

function geocode(query, address, country) {
  return new Promise((resolve, reject) => {
    // console.log(`geocoding >${query}<`);
    const mapboxURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(query)}.json?&autocomplete=false&country=${country}&limit=1&access_token=pk.eyJ1IjoiZGllZ29nYXJjaWFyIiwiYSI6ImNra2VlbXUzMzExcGUyeWt4a3RoM2N0a20ifQ.0AOINLBBugdgXaGX7cSDng`;
    axios.get(mapboxURL).then((response) => {
      // console.log("request finished");
      const body = response.data;

      if (body.features && body.features[0]) {
        const result = body.features[0];
        console.log(`resolved for ${query}`);
        const wikiCode = result.properties.wikidata || result.context
          .find((context) => context.wikidata).wikidata;
        return resolve({
          coordinates: { lat: result.center[1], long: result.center[0] }, location: address === "" ? result.text : query, id: wikiCode, address: result.place_name,
        });
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      return reject("error, address not found");
    }).catch((e) => {
      console.log(`Error ${e.message}`);
      // eslint-disable-next-line prefer-promise-reject-errors
      reject("no result");
    });
  });
}

async function searchLocation(location, address, country) {
  console.log(`Searching: ${location} at: ${address} "${country}"`);
  if (country !== "") {
    const searchQuery = (address === "") ? location : address;
    console.log(`query: ${searchQuery}`);

    if (searchQuery === "") {
      console.log("no location nor address, skipping");
      // eslint-disable-next-line no-throw-literal
      throw "no location nor address, skipping";
    }

    try {
      const response = await geocode(searchQuery, address, country);
      console.log(`the response is ${response}`);
      return response;
    } catch (error) {
      console.log("geocode errror");
      if (address !== "") {
        console.log(`query ${searchQuery}  not found, searching only for with location`);
        try {
          return await geocode(location, address, country);
        } catch (newError) {
          console.log(`geocode with location ${location} error`);
          console.log(newError);
          throw Error(newError);
        }
      } else {
        console.log(error);
        throw Error(error);
      }
    }
  } else {
    console.log("error, no country");
    throw Error("error, no country");
  }
}

function formatTravel(activity, date, duration, location, destinLocation) {
  const travel = activity;
  travel.origin = {
    name: location,
    date,
  };
  travel.destin = {
    name: destinLocation,
    date: new Date(date.getTime() + (duration || 60) * 60000),
  };
  return travel;
}
function formatEvent(activity, date, duration, location) {
  const event = activity;

  event.location = {
    date,
    name: location,
  };

  if (duration !== undefined) {
    event.duration = duration;
  }
  return event;
}

const fillLocation = async (location, address, country, activity, field) => {
  try {
    const result = await searchLocation(location, address, country);
    const filedActivity = activity;
    filedActivity[field].coordinates = result.coordinates;
    filedActivity[field].name = result.location;
    filedActivity[field].address = result.address;
    if (result.id !== undefined) {
      filedActivity[field].wiki_code = result.id;
    }
    return filedActivity;
  } catch (e) {
    console.log('fillLocation error');
    console.log(e);
    return activity;
  }
};

const readActivity = async (row, rowValues, type, workbook) => {
  let aux = 1;
  // eslint-disable-next-line no-plusplus
  const nextCellText = (() => row.getCell(aux++).text);

  const name = nextCellText();
  if (name === undefined || name === "") {
    // eslint-disable-next-line no-throw-literal
    throw 'no-name';
  }

  console.log('parsing: ', name);

  const description = nextCellText() || '';
  const image = nextCellText();
  const location = nextCellText();
  const address = nextCellText();
  const country = findCountryCode(workbook, nextCellText().toLowerCase()) || "";

  let destinLocation = "";
  let destinAddress = "";
  let destinCountry = "";
  if (type === 'travel') {
    destinLocation = nextCellText();
    destinAddress = nextCellText();
    destinCountry = findCountryCode(workbook, nextCellText().toLowerCase()) || "";
  }

  const time = rowValues[aux++];
  const day = rowValues[aux++];
  const month = rowValues[aux++];
  const year = rowValues[aux++];
  const durationTime = rowValues[aux++];
  const alarmCheck = rowValues[aux++];
  const reminderStr = rowValues[aux++] || "No";

  const date = getDate(day, month, year, time);

  const alarm = alarmCheck === "Yes";
  const reminder = getReminder(reminderStr);
  const duration = getDuration(durationTime);

  const activity = {
    name,
    description,
    alarm,
    reminder,
    files: { header: image },
  };

  if (type === 'travel') {
    let travel = formatTravel(activity, date, duration, location, destinLocation);

    travel = await fillLocation(location, address, country, travel, 'origin');
    travel = await fillLocation(destinLocation, destinAddress, destinCountry, travel, 'destin');

    return travel;
  }
  let event = await formatEvent(activity, date, duration, location);
  console.log(event.name);
  event = fillLocation(location, address, country, event, 'location');
  return event;
};

const parseRow = (workbook, sheet, type) => new Promise((resolve) => {
  const worksheet = workbook.getWorksheet(sheet);
  const events = [];
  const promises = [];
  console.log("parsing rows of", type, "total rows:", worksheet.rowCount);
  // if(i>)
  for (let i = 2; i <= worksheet.rowCount; i++) {
    console.log("doing row, ", i);
    const row = worksheet.getRow(i);
    const rowVlues = worksheet.getRow(i).values;
    promises.push(readActivity(row, rowVlues, type, workbook)
      .then((event) => { events.push({ ...event, id: i }); })
      .catch(() => { }));
  }
  Promise.all(promises).then(() => {
    resolve(events);
  });
});

const parseSpreadsheet = (file) => new Promise((resolve, reject) => {
  console.log('starting parseSpreadsheet with file', file.name);
  const reader = new FileReader();

  reader.onload = (e) => {
    console.log("loaded file... opening excel");
    const workbook = new Excel.Workbook();
    workbook.xlsx.load(e.target.result).then(async () => {
      console.log("excel workbook opened, parsing");
      const events = await parseRow(workbook, 1, 'event');
      const travels = await parseRow(workbook, 2, 'travel');

      resolve({ events, travels });
    }).catch((error) => {
      console.log(error);
      // eslint-disable-next-line prefer-promise-reject-errors
      reject({ success: false });
    });
  };
  reader.readAsArrayBuffer(file);
});

const demoParse = () => new Promise((resolve, reject) => {
  const workbook = new Excel.Workbook();
  workbook.xlsx.readFile('./triploop.xlsx').then(async () => {
    const events = await parseRow(workbook, 1, 'event');
    const travels = await parseRow(workbook, 2, 'travel');
    resolve({ events, travels });
  }).catch((error) => {
    console.log(error);
    // eslint-disable-next-line prefer-promise-reject-errors
    reject({ success: false });
  });
});

export default { parseSpreadsheet, demoParse };
